/**
 * Takes address with country in ISO string format and returns a new address
 * with the same country as an ID number
 * @param address address with country property in ISO format
 * @param application active application service
 */const convertAddressCountryToId=(a,b)=>{var c;return{...a,country:null===(c=b.countries.getByIso(a.country||""))||void 0===c?void 0:c.id}};export{convertAddressCountryToId};